import { type FC, type ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';

import classnames from 'classnames';
import styles from './RecommendedItemsWrapper.scss';

type Props = {
    children: ReactNode;
    isMobile?: boolean;
};

export const RecommendedItemsWrapper: FC<Props> = ({ children, isMobile }) => {
    return (
        <div className={classnames(styles.wrapper, isMobile && styles.isSwiperCarousel)}>
            <div className={styles.header}>
                <HeadingLevel>
                    {Heading => (
                        <Heading className={styles.title}>
                            <FormattedMessage
                                id="RecommendedItemsCarousel.title"
                                defaultMessage="Recommended For You"
                            />
                        </Heading>
                    )}
                </HeadingLevel>
            </div>
            {children}
        </div>
    );
};
